<div mat-dialog-title class="flex-container">
    <button mat-button class="close" [mat-dialog-close]="true">
      <mat-icon>close</mat-icon>
    </button>
    <h1>Edit Project</h1>

  </div>
  <div mat-dialog-content>
    <form [formGroup]="_projectForm">
      <div class="row">

        <div class="col-lg-6">
          <p>Client Name<span>*</span></p>
          <mat-form-field appearance="none" class="manage-input disabled">
            <mat-select formControlName="clientId"  placeholder="Select Client" required>
              <mat-option *ngFor="let client of clients" [value]="client.clientId">{{ client.clientName }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <p>Client ID<span>*</span></p>
          <mat-form-field appearance="none" class="manage-input disabled">
            <mat-select formControlName="clientId"  placeholder="Select Client" required>
              <mat-option *ngFor="let client of clients" [value]="client.clientId">{{ client.clientId }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <p>Project Name <span>*</span></p>
          <mat-form-field appearance="none" class="manage-input disabled">
            <input matInput placeholder="Enter Project Name" formControlName="projectName" required>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <p>Project ID <span>*</span></p>
          <mat-form-field appearance="none" class="manage-input disabled">
            <input matInput placeholder="Project ID" formControlName="projectId" required>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <p>Assessment Type<span>*</span></p>
          <mat-form-field appearance="none" class="manage-input">
            <mat-select formControlName="assessmentType"  placeholder="Select Assessment Type" required>
              <mat-option value="AWV">AWV</mat-option>
              <mat-option value="AWV_CRA">AWV_CRA</mat-option>
              <mat-option value="PD">PD</mat-option>
              <mat-option value="AWV_PD">AWV_PD</mat-option>
              <mat-option value="AWV_CRA_PD">AWV_CRA_PD</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <p>Max Call Limit <span>*</span></p>
          <mat-form-field appearance="none" class="manage-input">
            <input matInput type="number" min="0" placeholder="Max Call Limit" formControlName="maxCallLimit" required>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
            <p>Project Start Date <span>*</span></p>
            <mat-form-field appearance="none" class="manage-input disabled">
              <input matInput [matDatepicker]="projectStartDate" formControlName="projectStartDate" required>
              <mat-datepicker-toggle matSuffix [for]="projectStartDate"></mat-datepicker-toggle>
              <mat-datepicker #projectStartDate></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="col-lg-6">
            <p>Project End Date <span>*</span></p>
            <mat-form-field appearance="none" class="manage-input">
                <input matInput [matDatepicker]="projectEndDate" [min]="minEndDate" formControlName="projectEndDate" required>
                <mat-datepicker-toggle matSuffix [for]="projectEndDate"></mat-datepicker-toggle>
                <mat-datepicker #projectEndDate></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="col-lg-6">
          <p>Visit Type <span>*</span></p>
          <mat-form-field appearance="none" class="manage-select">
            <mat-select formControlName="visitTypes" placeholder="Select Visit Type" multiple required>
                <mat-option *ngFor="let visit of visitTypes" [disabled]="enableReset" [value]="visit.value">{{visit.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <p>Visit Duration<span>*</span></p>
          <mat-form-field appearance="none" class="manage-select">
            <mat-select formControlName="visitDuration" placeholder="Select Visit Duration" required>
              <mat-option value="30">30 min</mat-option>
              <mat-option value="60">60 min</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-12">
          <p>Description</p>
          <mat-form-field appearance="none" class="manage-textarea">
            <textarea matInput formControlName="projectDesc" placeholder="Enter Project Info"></textarea>
          </mat-form-field>
        </div>

        <app-tests *ngIf="tests" [availableTests]="tests" [isEditTests]="true" class="col-lg-12"></app-tests>

        <div class="col-lg-12 toparea">
          <button n-submit mat-raised-button mat-button class="btn btn-icon-text Action-buttons md-button-right" (click)="onSubmit()" [disabled]="!_projectForm.valid">
            SAVE PROJECT
          </button>
        </div>

      </div>
    </form>
  </div>
